export type ManualReviewReason = 'ai_unavailable' | 'share_allocation';

export const MANUAL_REVIEW_MESSAGES: Record<ManualReviewReason, string> = {
  ai_unavailable: 'AI extraction was unavailable — enter the contract terms manually below.',
  share_allocation:
    'AI found the contract terms, but the shares add up to more than 100%. Please review and correct them below.',
};
